import React from 'react'

import { discount_desc } from '../../../constants'
import { ProductShelfByFilters } from '../ProductShelf/ProductShelfByFilters'

import type { ProductLayout } from '../../../types/Product'

interface HistorySearchShelfProps {
  term: string
  layout?: ProductLayout
}

const PRODUCTS_TO_FETCH = 8
const PRODUCTS_TO_SHOW = 4

export const HistorySearchShelf = ({
  term,
  layout,
}: HistorySearchShelfProps) => {
  return (
    <ProductShelfByFilters
      queryInput={{
        sort: discount_desc,
        term: term,
        firstItems: PRODUCTS_TO_FETCH,
      }}
      limit={PRODUCTS_TO_SHOW}
      id="vitrine-relacionado-com-suas-buscas"
      variant="horizontal"
      backgroundColor="var(--color-grayScale-light)"
      title="Você também pode gostar"
      layout={layout}
      propsCarousel={{ arrow: {}, bullet: {} }}
      className="showcase-related-container"
    />
  )
}
